import React, { useState } from "react";
import './Login.css'
import { RotateSpinner } from "react-spinners-kit";
import { useNavigate } from "react-router-dom";
import Swal from 'sweetalert2';
import { BASE_URL } from './apiConfig';

export default function Login() {
    const [username, setUsername] = useState(null);
    const [password, setPassword] = useState("");
    const [showprogress, setshowprogress] = useState(false);


    const navigate = useNavigate();

    const handleLogin = async () => {
        try {
            setshowprogress(true);

            if (!username || !password) {
                setshowprogress(false);
                console.error("Please fill in all fields and verify captcha.");
                Swal.fire({
                    title: 'Error Occurred',
                    html: 'Please Check Either Username or password is not entered,',
                    icon: 'error'
                });
            }

            else {
                // Proceed with login logic
                const apiUrl = `${BASE_URL}/Login`;

                const response = await fetch(apiUrl, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({
                        guiuserid: username,
                        guipassword: password,
                    }),
                });

                if (response.ok) {
                    // Login successful
                    setshowprogress(false);
                    const data = await response.json();
                   // console.log("Login successful:", data);
                    sessionStorage.setItem("loginData", JSON.stringify(data));
                    sessionStorage.setItem("username", data?.apiuserid);
                    //console.log("apiuserid:", data?.apiuserid)
                    navigate("/");
                }

                else {
                    // Login failed
                    setshowprogress(false);
                    Swal.fire({
                        title: 'Invalid Credentials',
                        html: 'The entered username, password are not valid.',
                        icon: 'error'
                    });
                    console.error("Login failed:", response.statusText);
                }

            }

        }

        catch (error) {
            console.error("API Request Error:", error.message);
            setshowprogress(false);
            Swal.fire({
                title: 'API Request Error',
                html: error.message,
                icon: 'error'
            });
        }
    };

    return (
        <div className="Login-outermost-container">
            <div className="center-div">
                <div className="center-left-div" style={{ position: "relative", width: "fit-content" }}>
                    <img src="images/bgimage.png" />
                    <img src="images/logo-Vconnect.png" style={{ width: "7rem", height: "3.2rem", position: "absolute", top: "10px", left: "10px" }} />
                </div>

                <div className="center-right-div" >


                    <div style={{ position: "relative", minHeight: "400px" }}>
                        {showprogress && (
                            <div className="spinner-overlay">
                                <div className="custom-spinner"></div>
                            </div>
                        )}


                        <div className={showprogress === true ? "heading-div blurred" : "heading-div"} >
                            <span>Account Login</span>
                        </div>

                        <div className={showprogress === true ? "inputbox-div blurred" : "inputbox-div "}>
                            <div className="form-group clearfix">
                                <div className="form-box">
                                    <input name="Username" type="Username" className="form-control" id="first_field" placeholder="Username" aria-label="Username" style={{ fontSize: "16px", color: "grey" }}
                                        value={username}
                                        onChange={(e) => setUsername(e.target.value)} maxLength="45" />
                                    <i className="fa fa-envelope" aria-hidden="true"></i>

                                </div>
                            </div>

                            <div className="form-group clearfix">
                                <div className="form-box">
                                    <i className="fa fa-lock" aria-hidden="true"></i>
                                    <input name="password" type="password" className="form-control" autoComplete="off" id="second_field" placeholder="Password" aria-label="Password" style={{ fontSize: "16px", color: "grey" }}
                                        value={password}
                                        onChange={(e) => setPassword(e.target.value)} maxLength="45" />
                                </div>
                            </div>
                        </div>

                        <div className={showprogress === true ? "btn-div blurred" : "btn-div"}>
                            <div className="form-group clearfix">
                                <button type="submit" className="btn btn-info btn-lg btn-theme w-100" onClick={handleLogin} >Login</button>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    );
}